/* global process */

// baseUrl.js

// Check if the application is in production
// const isProduction = process.env.NODE_ENV === 'production';

// Determine the base URL based on the environment

// const baseUrl = isProduction
//   ? process.env.REACT_APP_BACKEND_URL_PROD // Use production backend URL
//   : process.env.REACT_APP_BACKEND_URL_DEV; // Use development backend URL

// or

//local url
// const baseUrl = 'http://localhost/wp-avanttech3';
//live backend
const baseUrl = process.env.REACT_APP_CMS_URL;

export default baseUrl;
